import React, { useState, useEffect } from 'react';
import DoneIcon from '@material-ui/icons/Done';
import { Search, DeleteForever, Visibility } from '@material-ui/icons';
import { Container, Grid, Typography, FormControl, FormGroup, FormControlLabel, Checkbox, ButtonGroup, Dialog, AppBar, Button, Slide, Toolbar } from '@material-ui/core/';
// PAGINAS
import ApiServices from 'services/ApiServices';
import CitizenIdentityData from './citizenIdentityData';
// REDUX
import { connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// COMPONENTES
import BotonElement from 'components/BotonTable';
import BotonPersonalizado from 'components/BotonNormal'
import Table from 'components/Table';
import modalStyles from 'components/ModalConfirmation/styles';
import { functions } from 'constants/index';
import CustomToolTip from 'components/tooltip/';
import MensajeAlerta from 'components/ResponseElement'
import ModalConfirmation from 'components/ModalConfirmation/ModalConfirmation';
import DialogLoadingMessage from 'components/BackDrop';
import { showMessagePersonalizedPosition } from 'services/SweetAlert';
// ESTILOS
import { useStyles } from "./style";
import Form from 'components/Form/FormTwoColumns';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const citizenIdentityDataGlobal = [
    { tipo:'Fotografía', foto: ""},
    { tipo:'Firma', foto: ""},
    { tipo:'Huella', foto: ""},
];

const dataCitizenGeneral = {
    fullName: "",
    gender: "",
    dateOfBirth: "",
    birthPlace: "",
    fatherFullName: "",
    motherFullName: "",
    padronData: {
        codStatus: "",
        nombreStatus: "",
    }
}

function Homonimos(props) {
    const classes = useStyles(),
        classesModal = modalStyles(),
        [header, setHeader] = useState([
            { title: 'Código de Referencia', field: 'id', cellStyle: { maxWidth: '80px' } },
            { title: 'Nombre Completo', field: 'nombres', cellStyle: { maxWidth: '100px' } },
            { title: 'Estado Padrón', field: 'datosPadron.estadoPadron.nombreStatus',
                render: rowData => 
                (rowData.datosPadron.estadoPadron.codStatus === 0) ?
                    <div style={{backgroundColor: 'red', color: 'white'}}>{rowData.datosPadron.estadoPadron.nombreStatus}</div> :
                (rowData.datosPadron.estadoPadron.codStatus === 1) ?
                    <div style={{backgroundColor: '#EC8B00', color: 'white'}}>{rowData.datosPadron.estadoPadron.nombreStatus}</div> :
                (rowData.datosPadron.estadoPadron.codStatus === 2) ?
                    <div style={{backgroundColor: '#EC8B00', color: 'white'}}>{rowData.datosPadron.estadoPadron.nombreStatus}</div> :
                    <div>{rowData.datosPadron.estadoPadron.nombreStatus}</div>            
            },
            { title: 'CUI del DPI', field: 'datosPadron.dpi.cui', cellStyle: { maxWidth: '100px' } },
            { title: 'Género', field: 'genero' },
            { title: 'Cédula', field: 'cedula' },
            { title: 'Departamento Cédula', field: 'departamentoCedula.nombre' },
            { title: 'Municipio Cédula', field: 'municipioCedula.name' },
            { title: 'Fecha Nacimiento', field: 'fechaNacimiento', render: (rowData) => functions.splitDate(rowData.fechaNacimiento) },
            { title: 'Departamento Nacimiento', field: 'departamentoNacimiento.nombre' },
            { title: 'Municipio Nacimiento', field: 'municipioNacimiento.name' },
            {
                title: 'Ver imágenes', field: 'showImages',
                render: rowData => <div>
                    {
                        <CustomToolTip title="VER FOTO, FIRMA, HUELLA" handleFunction={() => validarIdentidad(rowData)}><Visibility/></CustomToolTip>
                    }
                </div>
            },
            {
                title: 'Acción', field: 'accion',
                render: rowData => <div>
                    {
                        <ButtonGroup color="primary" aria-label="outlined primary button group">
                            <BotonElement icon={<DoneIcon />} title="Seleccionar ciudadano" function={() => seleccionarCiudadano(rowData)} />
                        </ButtonGroup>
                    }
                </div>
            },
        ]),
        [controller] = useState("verificarHomonimos"),
        // data
        [listHomonimos, setListHomonimos] = useState(props.arrayHomonimos),
        [citizenIdentityData, setCitizenIdentityData] = useState([...citizenIdentityDataGlobal]),
        [citizenDataSpecialCase, setCitizenDataSpecialCase] = useState([]),
        [citizenIdentityDataGeneral, setCitizenIdentityDataGeneral] = useState({...dataCitizenGeneral}),
        // loadings and alerts
        [loading, setLoading] = useState(false),
        [mensaje, setMensaje] = useState({ tipoError: '', tipoMensaje: '' }),
        [messageModal, setMessageModal] = useState(""),
        [messageAlert, setMessageAlert] = useState(""),
        [dataConfirmation, setDataConfirmation] = useState({}),
        // modals
        [open, setOpen] = useState(false),
        [modalSpecialCase, setModalSpecialCase] = useState(false),
        [modalConfirmation, setModalConfirmation] = useState(false),
        [showCitizenIdentityData, setShowCitizenIdentityData] = useState(false),
        [checkAutorization, setCheckAutorization] = useState(false);
        // elements para el formTwoColumns
        const [elements,setElements] = useState({
            observacion: { idelement: "observacion",  value:'', label: "Observación", pattern:"^[\\w1-9 _Ññ.,!¡\"#$%&/()=¿?'@*-]{0,1024}$", validators: ['required'], errorMessages:['Observación requerido, Sin espacios al inicio y final'], isError:false, elementType:'input',},
            // contraseña: {  idelement: "contraseña",  value:'', label: "Contraseña *", pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:;{}+=^~|%*¿?&/-]\\S{6,20}$", validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password' },
        });   
        const [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});

    const [state, setState] = useState({
        municipioNacio: false, departamentoNacio: false, fechaNacio: false, nom1: false, nom2: false, ape1: false, ape2: false,
        cui: false, cedula: false,
        
    });
    let filtros = {
        municipioNacio: '0', departamentoNacio: '0', fechaNacio: '', nom1: '', nom2: '', ape1: '', ape2: '',
        cui: '', ordenCedula: '', registroCedula:'',
    };

    useEffect(() => {
        if (listHomonimos.length === 0) {
            setData();
        }
    }, [props.showDialogHomonimos]);

    const setData = () => {
        const name1 = props.datosGeneralesDelCiudadano?.nom1 ? true : false;
        const name2 = props.datosGeneralesDelCiudadano?.nom2 ? true : false;
        const apelli1 = props.datosGeneralesDelCiudadano?.ape1 ? true : false;
        const apelli2 = props.datosGeneralesDelCiudadano?.ape2 ? true : false;
        const fechaNacimiento = props.datosGeneralesDelCiudadano?.fechaNacimiento ? true : false;
        setState({ ...state, nom1: name1, nom2: name2, ape1: apelli1, ape2: apelli2, fechaNacio: fechaNacimiento});
        setListHomonimos(props.arrayHomonimos)
    }

    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    const buscarInformacion = async () => {
        setLoadingMessage({loading: true, title:'Buscando Homónimos ...'})
        if (state.cui || state.nom1 || state.nom2 || state.ape1 || state.ape2 || state.cedula) {
            setCheckAutorization(true);
            setListHomonimos([])
            filtros.fechaNacio = state.fechaNacio ? functions.dateFormatGeneral(props.datosGeneralesDelCiudadano.fechaNacimiento) : "";
            if (state.departamentoNacio) filtros.departamentoNacio = props.datosGeneralesDelCiudadano.departamentoNacio.id;
            if (state.departamentoNacio) filtros.municipioNacio = props.datosGeneralesDelCiudadano.municipioNacio.id.id || props.datosGeneralesDelCiudadano.municipioNacio.id;
            filtros.nom1 =    state.nom1 ? props.datosGeneralesDelCiudadano.nom1 : ""
            filtros.nom2 =    state.nom2 ? props.datosGeneralesDelCiudadano.nom2 : ""
            filtros.ape1 =    state.ape1 ? props.datosGeneralesDelCiudadano.ape1 : ""
            filtros.ape2 =    state.ape2 ? props.datosGeneralesDelCiudadano.ape2 : ""
            filtros.cui =     state.cui ? props.datosGeneralesDelCiudadano.cui : ""
            filtros.ordenCedula =       state.cedula ? props.datosGeneralesDelCiudadano.ordenCedula : ""
            filtros.registroCedula =    state.cedula ? props.datosGeneralesDelCiudadano.registroCedula : ""
            // filtros.cedula =  state.cedula ? props.datosGeneralesDelCiudadano.cedula : "";
            // filtros.genero = state.genero ? props.datosGeneralesDelCiudadano.genero : "";            

            try {
                const hasPermission = await ApiServices.userSecurity.hasPermission('verificarHomonimos','list');    
                if (hasPermission.error) {
                    setCheckAutorization(false);
                    showMessagePersonalizedPosition('error', '¡Advertencia! ' , hasPermission?.error?.message)
                    return;
                }
               ApiServices[controller].initSearchCriteria.clear();
               ApiServices[controller].initSearchCriteria.setOperator("and");
               ApiServices[controller].initSearchCriteria.addEquals("municipioNacio", filtros.municipioNacio);  
               ApiServices[controller].initSearchCriteria.setOperator("and");
               ApiServices[controller].initSearchCriteria.addEquals("departamentoNacio", filtros.departamentoNacio);  
               ApiServices[controller].initSearchCriteria.setOperator("and");
               ApiServices[controller].initSearchCriteria.addEquals("fechaNacio", filtros.fechaNacio);  
               ApiServices[controller].initSearchCriteria.setOperator("and");
               ApiServices[controller].initSearchCriteria.addEquals("nom1", filtros.nom1);  
               ApiServices[controller].initSearchCriteria.setOperator("and");
               ApiServices[controller].initSearchCriteria.addEquals("nom2", filtros.nom2);  
               ApiServices[controller].initSearchCriteria.setOperator("and");
               ApiServices[controller].initSearchCriteria.addEquals("ape1", filtros.ape1);  
               ApiServices[controller].initSearchCriteria.setOperator("and");
               ApiServices[controller].initSearchCriteria.addEquals("ape2", filtros.ape2);  
               ApiServices[controller].initSearchCriteria.setOperator("and");
               ApiServices[controller].initSearchCriteria.addEquals("cui", filtros.cui);  
               ApiServices[controller].initSearchCriteria.setOperator("and");
               ApiServices[controller].initSearchCriteria.addEquals("ordenCedula", filtros.ordenCedula);  
               ApiServices[controller].initSearchCriteria.setOperator("and");
               ApiServices[controller].initSearchCriteria.addEquals("registroCedula", filtros.registroCedula);  
            //    ApiServices[controller].initSearchCriteria.setOperator("and");
            //    ApiServices[controller].initSearchCriteria.addEquals("genero", filtros.genero);   
               setCheckAutorization(false);
           
            } catch (error) {
                if (error.status === 404) {
                    showMessagePersonalizedPosition('error', '¡Advertencia! ' , 'Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                } else {
                    showMessagePersonalizedPosition('error', '¡Advertencia! ' , 'Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                }
            }
        } else {
            showMessagePersonalizedPosition('error', '¡Advertencia! ' ,'Tiene que filtrar como minimo CUI, Primer Nombre, Segundo Nombre, Primer Apellido, Segundo Apellido o Cédula.')
        }
        setLoading(false)
        setLoadingMessage({loading: false, title:''})
    }

    const limpiarFiltros = () => {
        setState({
            ...state, nom1: false, nom2: false, ape1: false, ape2: false, cui: false,
            cedula: false, fechaNacio: false, departamentoNacio: false, municipioNacio: false
        })
    }

    const validarQueSteperUsar = () => {
        // cuando sea origen portal web, usar steper de solicitudes portal web
        if(props.isPortalWeb === true) {
            props.SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB(props.stepPortalWeb+1);
        } else {
            props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(props.step + 1);
        }
    }

    const nextStep = () => {
        // Cuando le agrege la validacion dentro de esta funcion no realizaba la instruccion, mejor lo realice en otra funcion
        validarQueSteperUsar()
        //     props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(props.step + 1); 
        // props.SOLICITUD_EMPADRONAMIENTO_SET_HOMONIMOS(elements);
    };

    // const beforeStep=()=>{
    //     props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(props.step-1);    
    // };    

    const Cerrar = () => {
        // beforeStep()
        props.cerrarDialogo()
    };

    // const CancelarSolicitud=()=>{
    //     props.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD(true)
    //     props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step+2);
    // };

    const handClose = (event, reason) => {
        if (reason === 'clickaway') { return; }
        setOpen(false)
    }

    // Validar si CUI seleccionado con CUI Ingresado
    const seleccionarCiudadano = (data) => {
        let DPIciudadano = props.isPortalWeb ? props.datosPortalWeb.datosDpiSolicitudEmpadronamiento.cui : props.datosSolicitudExtranjero?.dpi

        setDataConfirmation({})
        setMessageModal("");
        if(data.datosPadron.dpi) {
            if(DPIciudadano != data.datosPadron.dpi?.cui) {
                // mostrar alerta que cui ingresado anteriormente con el seleccionado son diferentes ¿Está seguro de continuar?
                // if(!props.isManual) {
                //     nextStepCitizenSelected({...data, isCuiDistint : false, isAssociation: false})
                //     return;
                // }
                setMessageModal("El ciudadano seleccionado posee un CUI distinto al ingresado, ¿está seguro que el número de CUI le corresponde al ciudadano?")
                setModalConfirmation(true);
                setDataConfirmation({...data, isCuiDistint : true})
            } else {
                if(Number(data.status) === 16) {
                    setMessageModal(`Usted va asociar el número de cui ${DPIciudadano} al número de boleta ${data.datosPadron?.nroBoleta} del ciudadano ${data?.nombres}`)
                    setModalConfirmation(true);
                    return setDataConfirmation({...data, isCuiDistint : false, })
                }
                // Los cui son iguales procede a continuar sin mostrar alerta
                nextStepCitizenSelected({...data, isCuiDistint : false, })
            }
        } else {
            if(Number(data.status) === 16) {
                setMessageModal(`Usted va asociar el número de cui ${DPIciudadano} al número de boleta ${data.datosPadron?.nroBoleta} del ciudadano ${data?.nombres}`)
                setModalConfirmation(true);
                return setDataConfirmation({...data, isCuiDistint : false, })
            }
            if(!props.isManual) {
                nextStepCitizenSelected({...data, isCuiDistint : false, })
                return;
            }
            setOpen(true)
            setMensaje({ tipoError: 'error', tipoMensaje: `¡Oops! No encontramos datos del DPI en nuestros registros` })
        }
    }

    // Setear la data y mover al paso siguiente
    const nextStepCitizenSelected = (data) => {
        let objetoDatosCiudadadoSolicitudPortalWeb = {...props.datosPortalWeb};

        // SI LA SOLICITUD ES ORIGEN PORTAL WEB CONSTRUIMOS UN OBJETO PARA SETEAR LA DATA REQUERIDA A MOSTRAR EN LA SIGUIENTE PANTALLA
        if(props.isPortalWeb) {
            console.log("************ COMPONENTE HOMONIMOS ***********");
                // DATA PROVENIENTE DEL PADRON
            const {
                dpi: {departamentoVecindadRenap, municipioVecindadRenap, departamentoCedula, municipioCedula, ordenCedulaRef, registroCedulaRef, cui, fechaEmision, serie, fechaAsientoNacimiento, departamentoNacimientoRenap, municipioNacimientoRenap, numeroFolioNacimiento, numeroLibroNacimiento, numeroPartidaNacimiento },
                complemento: {
                    fechaNacionalizacion,
                    telefono,
                    primerNombrePadre,
                    segundoNombrePadre,
                    primerApellidoPadre,
                    segundoApellidoPadre,
                    primerNombreMadre,
                    segundoNombreMadre,
                    primerApellidoMadre,
                    segundoApellidoMadre,
                    email,
                    profesionDescripcion,
                },
                primerNombre,
                segundoNombre,
                primerApellido,
                segundoApellido,
                tercerApellido,
                genero,
                alfabetismo,
                noVidente,
                fechaNacimiento,
                departamentoResidencia,
                municipioResidencia,
                direccion,
                nroBoleta,
                statusPadron

            } = data.datosPadron;
            console.log("CUI QUE VIENE DEL PADRÓN", cui);
            props.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI_PORTAL_WEB(cui)

            objetoDatosCiudadadoSolicitudPortalWeb = {
                ...objetoDatosCiudadadoSolicitudPortalWeb,
                // id,
                primerNombre,
                segundoNombre,
                primerApellido,
                segundoApellido,
                tercerApellido,
                genero,
                // alfabetismo,
                // noVidente,
                fechaNacimiento,
                // departamentoResidencia,
                // municipioResidencia:  {
                //     "id": {
                //         "id": municipioResidencia?.id || 0,
                //         "departamentoId": municipioResidencia?.departamentoId || 0
                //     },
                //     "name": municipioResidencia?.name || ""
                // },
                // direccion,
                datosDpiSolicitudEmpadronamiento:{
                    ...props.datosPortalWeb.datosDpiSolicitudEmpadronamiento,
                    departamentoVecindad: departamentoVecindadRenap,
                    municipioVecindad: municipioVecindadRenap,
                    departamentocedula: departamentoCedula ,
                    municipioCedula,
                    ordenCedulaRef,
                    registroCedulaRef,
                    cui,
                    fechaEmisionDPI: fechaEmision,
                    serieDPI: serie,
                    fechaAsientoNacimientoDPI: fechaAsientoNacimiento,
                    departamentoNacimiento: departamentoNacimientoRenap,
                    municipioNacimieno: municipioNacimientoRenap,
                    numeroLibroNacimientoDPI: numeroLibroNacimiento,
                    numeroFolioNacimientoDPI:  numeroFolioNacimiento,
                    numeroPartidaNacimientoDPI: numeroPartidaNacimiento
                },
                complementoSolicitudesEmpadronamiento:{
                    ...props.datosPortalWeb.complementoSolicitudesEmpadronamiento,
                    fechaNacionalizacion,
                    // telefono,
                    primerNombrePadre,
                    segundoNombrePadre,
                    primerApellidoPadre,
                    segundoApellidoPadre,
                    primerNombreMadre,
                    segundoNombreMadre,
                    primerApellidoMadre,
                    segundoApellidoMadre,
                    // email,
                    // profesionName: profesionDescripcion,
                },
                estadoHomonimoSeleccionado: statusPadron

            }
            props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_PORTAL_WEB(objetoDatosCiudadadoSolicitudPortalWeb)
            props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE(objetoDatosCiudadadoSolicitudPortalWeb)
          } else {
            props.SET_DATA_HOMONIMO_CIUDADANO(data)
          }
        nextStep();
    }

    const sendDataConfirmation = () => {
        nextStepCitizenSelected(dataConfirmation)
    }


    const closeModalConfirmation = () => {
        setModalConfirmation(false);
    } 

    const validarIdentidad = async (data) => {
        setLoadingMessage({loading: true, title:'Buscando datos de identidad ...'})
        setCitizenIdentityData([...citizenIdentityDataGlobal]);
        setCitizenIdentityDataGeneral({...dataCitizenGeneral})
        setShowCitizenIdentityData(false)

        const {datosPadron = {}, departamentoNacimiento ={}, municipioNacimiento = {}, genero ="", fechaNacimiento= ""} = data;
        const newData = {};
        newData.fullName = `${datosPadron?.primerNombre ? datosPadron?.primerNombre : ""} ${datosPadron?.segundoNombre ? datosPadron?.segundoNombre : ""} , ${datosPadron?.primerApellido ? datosPadron?.primerApellido : ""} ${datosPadron?.segundoApellido ? datosPadron?.segundoApellido : ""} `;
        newData.gender = genero;
        newData.dateOfBirth = fechaNacimiento;
        newData.birthPlace = `${datosPadron.dpi?.municipioNacimientoTSE?.municipio ? `${datosPadron.dpi?.municipioNacimientoTSE?.municipio}, ` : ""} ${datosPadron.dpi?.departamentoNacimientoTSE?.name ? datosPadron.dpi?.departamentoNacimientoTSE?.name: ""}`;
        newData.fatherFullName = `${datosPadron?.complemento?.primerNombrePadre ? datosPadron?.complemento?.primerNombrePadre : ""} ${datosPadron?.complemento?.segundoNombrePadre ? datosPadron?.complemento?.segundoNombrePadre : ""} , ${datosPadron?.complemento?.primerApellidoPadre ? datosPadron?.complemento?.primerApellidoPadre : ""} ${datosPadron?.complemento?.segundoApellidoPadre ? datosPadron?.complemento?.segundoApellidoPadre : ""} `;
        newData.motherFullName = `${datosPadron?.complemento?.primerNombreMadre ? datosPadron?.complemento?.primerNombreMadre : ""} ${datosPadron?.complemento?.segundoNombreMadre ? datosPadron?.complemento?.segundoNombreMadre : ""} , ${datosPadron?.complemento?.primerApellidoMadre ? datosPadron?.complemento?.primerApellidoMadre : ""} ${datosPadron?.complemento?.segundoApellidoMadre ? datosPadron?.complemento?.segundoApellidoMadre : ""} `;
        newData.padronData = datosPadron?.estadoPadron ? datosPadron?.estadoPadron : {};
        
        if(!data.datosPadron?.dpi?.cui) {
            setLoadingMessage({loading: false, title:''})
            setShowCitizenIdentityData(true)
            setCitizenIdentityDataGeneral(newData);
            return;
        }
       
        try{
            const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad(data.datosPadron?.dpi?.cui);
            if(response.error){
                props.CLEAR_CITIZEN_IDENTITY_DATA();
                setShowCitizenIdentityData(true)
                setCitizenIdentityDataGeneral(newData)
            } else {
                const {object} = response.data;

                if(!object) {
                    setShowCitizenIdentityData(true)
                    setCitizenIdentityDataGeneral(newData)
                }
                let newCitizenIdentityData = [];

                newCitizenIdentityData.push({ tipo:'Fotografía', foto: `data:image/jpeg;base64,${object.fotoCiudadano}`});
                newCitizenIdentityData.push({ tipo:'Firma', foto: `data:image/jpeg;base64,${object.firmaCiudadano}`});
                newCitizenIdentityData.push({ tipo:'Huella', foto: `data:image/jpeg;base64,${object.huellaCiudadano}`});
    
                setShowCitizenIdentityData(true)
                setCitizenIdentityData(newCitizenIdentityData)
                setCitizenIdentityDataGeneral(newData)
            } 
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
        }
        setLoadingMessage({loading: false, title:''})
    }

    const closeShowCitizenIdentityData = () => {
        setShowCitizenIdentityData(false)
    }

    const onSelectionChange= (rows, item) => {

        if(item) {
            if(citizenDataSpecialCase.length > 0) {
                const exist = citizenDataSpecialCase.some(({nroBoleta}) => nroBoleta == item.id)
                if(exist) {
                    const newData = citizenDataSpecialCase.filter( ({nroBoleta}) => nroBoleta != item.id);
                    setCitizenDataSpecialCase(newData)
                    return;
                }
                setCitizenDataSpecialCase([...citizenDataSpecialCase, {nroBoleta: item.id}])
                return;
            }

            setCitizenDataSpecialCase([{nroBoleta: item.id}])
            return;
        }

        if(rows.length > 0) {
            const newData = rows.map( ({id}) => ({nroBoleta: id}))
            setCitizenDataSpecialCase(newData)
        } else {
            setCitizenDataSpecialCase([])
        }
    }

    const openModalSpecialCase = () => {
        setModalSpecialCase(true)
    }

    const closeModalSpecialCase = () => {
        setModalSpecialCase(false)
    }

    const sendDataSpecialCase = async () => {
        elements['observacion'].isError = false;
        setElements({...elements})
        if(!elements['observacion'].value || citizenDataSpecialCase?.length === 0) {
            elements['observacion'].isError = true;
            setElements({...elements})
            return;
        }
        closeModalSpecialCase();
        const noTickets = citizenDataSpecialCase?.map( ({nroBoleta}) => nroBoleta);
        const message = `, los número de boletas son: ${noTickets?.toString()}` || ""
        const data = {
            cui: props.datosSolicitudExtranjero?.dpi,
            observaciones: elements['observacion'].value + message,
            numerosDeBoletaPorNotificar: citizenDataSpecialCase
        }
        try {
            setMessageAlert("Generando caso especial, Espere un momento por favor!")
            let response = await ApiServices.casosEspeciales.createRegister(data);
            if (response.error !== null) {
                setMensaje({ tipoError: 'error', tipoMensaje: 'Oops!. ' + response.error })
                setOpen(true)
            }
            else {
                setMensaje({ tipoError: 'success', tipoMensaje: response?.data || "Caso especial creado correctamente"})
                setOpen(true)
                setCitizenDataSpecialCase([])
            }
        } catch (error) {
            if (error.status === 404) {
                setMensaje({ tipoError: 'error', tipoMensaje: 'Oops!. Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.' })
                setOpen(true)
            } else {
                setMensaje({ tipoError: 'error', tipoMensaje: 'Oops!. Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.' })
                setOpen(true)
            }
        }

        elements['observacion'].value = "";
        setElements({...elements})
    }

    return (
        <div className={classes.root}>
            <Dialog
                open={props.showDialogHomonimos}
                fullScreen
                TransitionComponent={Transition}
                keepMounted
                onClose={props.cerrarDialogo}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                            Homónimos
                        </Typography>
                        <Button autoFocus color="inherit" onClick={props.cerrarDialogo}>
                            Cerrar
                        </Button>
                    </Toolbar>
                </AppBar>
                <div className={classes.containerContent}>
                    <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
                    <Container className={classes.colorComponente}>
                        <Grid container className={classes.marginGrid} >
                        {/* FILTROS */}
                            <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                                <Typography component="h2" variant="body1" color="textPrimary"> <strong>Homónimos</strong></Typography>
                            </Grid>
                            <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value={props.datosGeneralesDelCiudadano?.nom1}
                                            control={<Checkbox color="primary" checked={state.nom1} onChange={handleChange} name="nom1" />}
                                            label={"Primer Nombre (*): " + ((props.datosGeneralesDelCiudadano?.nom1 === null) ? "" : props.datosGeneralesDelCiudadano?.nom1)}
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value={props.datosGeneralesDelCiudadano?.nom2}
                                            control={<Checkbox color="primary" checked={state.nom2} onChange={handleChange} name="nom2" />}
                                            label={"Segundo Nombre: " + ((props.datosGeneralesDelCiudadano?.nom2 === null) ? "" : props.datosGeneralesDelCiudadano?.nom2)}
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value={props.datosGeneralesDelCiudadano?.ape1}
                                            control={<Checkbox color="primary" checked={state.ape1} onChange={handleChange} name="ape1" />}
                                            label={"Primer Apellido (*): " + ((props.datosGeneralesDelCiudadano?.ape1 === null) ? "" : props.datosGeneralesDelCiudadano?.ape1)}
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value={props.datosGeneralesDelCiudadano?.ape2}
                                            control={<Checkbox color="primary" checked={state.ape2} onChange={handleChange} name="ape2" />}
                                            label={"Segundo Apellido: " + ((props.datosGeneralesDelCiudadano?.ape2 === null) ? "" : props.datosGeneralesDelCiudadano?.ape2)}
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value={props.datosGeneralesDelCiudadano?.cui}
                                            control={<Checkbox color="primary" checked={state.cui} onChange={handleChange} name="cui" />}
                                            label={"CUI: " + ((props.datosGeneralesDelCiudadano?.cui) ? props.datosGeneralesDelCiudadano?.cui : "")}
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value={props.datosGeneralesDelCiudadano?.ordenCedula && props.datosGeneralesDelCiudadano?.registroCedula}
                                            control={<Checkbox color="primary" checked={state.cedula} onChange={handleChange} name="cedula" />}
                                            label={"Cédula: " + ((props.datosGeneralesDelCiudadano?.ordenCedula) ? props.datosGeneralesDelCiudadano?.ordenCedula+'-' : "") + ((props.datosGeneralesDelCiudadano?.registroCedula) ? props.datosGeneralesDelCiudadano?.registroCedula : "")}
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value="end"
                                            control={<Checkbox color="primary" checked={state.fechaNacio} onChange={handleChange} name="fechaNacio" />}
                                            // functions.splitDate(props.datosGeneralesDelCiudadano.fechaNacio)
                                            label={"Fecha Nacimiento: " + ((props.datosGeneralesDelCiudadano?.fechaNacimiento === null) ? "" : functions.dateFormatGeneral(props.datosGeneralesDelCiudadano?.fechaNacimiento))}
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} container direction="row" justify="flex-start" alignItems="flex-start">
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value="end"
                                            control={<Checkbox color="primary" checked={state.departamentoNacio} onChange={handleChange} name="departamentoNacio" />}
                                            label={`Lugar de Nacimiento: ${!props.datosGeneralesDelCiudadano?.departamentoNacio ? "" : props.datosGeneralesDelCiudadano?.departamentoNacio?.name}, ${!props.datosGeneralesDelCiudadano?.municipioNacio ? "" : props.datosGeneralesDelCiudadano?.municipioNacio?.name}`}
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                        {/* ACCIONES DE FILTROS */}
                            <Grid item xs={12} className={classes.buttons}>
                                <BotonPersonalizado title={"Buscar"} botonPersonalizado={true} function={buscarInformacion} icon={<Search />} loading={loading} disabled={loading} />
                                <BotonPersonalizado title={"Limpiar Filtros"} botonPersonalizado={true} function={limpiarFiltros} icon={<DeleteForever />} />
                            </Grid>
                            {/* <Grid item xs={12} className={classes.buttons}> */}
                                {/* {window.screen.width >= 1024 ? ( */}
                                    {
                                    (!checkAutorization ) &&
                                        (
                                            <>
                                            <Table
                                                    //pageSize={this.state.pageSize} 
                                                    service={ApiServices[controller]}
                                                    // title={"Listado de Homónimos Delegación/Sub-Delegación"}
                                                    title={"Listado de Homónimos"}
                                                    header={header}
                                                    //data={listHomonimos}
                                                    showFilter={false}
                                                    showFilterGeneral={false}
                                                    // selection={true}
                                                    // onSelectionChange={onSelectionChange}
                                                />
                                                <Grid item xs={12} className={classes.buttons}>
                                                    {/* <BotonPersonalizado title={"Regresar"} botonAnterior={true} function={beforeStep} /> */}
                                                    <BotonPersonalizado title={"Siguiente"} botonSiguiente={true} function={nextStep} />
                                                    {/* {citizenDataSpecialCase?.length > 0 &&  (
                                                        <BotonPersonalizado title={"Enviar a caso especial"} botonSiguiente={true} function={openModalSpecialCase} />
                                                    )} */}
                                                    {/* <BotonPersonalizado title={"Rechazar"}  botonRechazarDocumento={true} function={CancelarSolicitud} />  */}
                                                    <BotonPersonalizado title={"Cerrar"} botonNormalCancelar={true} function={Cerrar} />
                                                </Grid>
                                            </>
                                        )
                                    }
                                {/* // ) : ("")} */}
                            {/* </Grid> */}
                        </Grid><br />
                        {/* ALERTA TIPO DIALOGO */}
                        <MensajeAlerta type={mensaje.tipoError} content={mensaje.tipoMensaje} timeMessage={2000} open={open} handClose={handClose} />
                        <div className={classes.lineaDegradadaBottom}></div>
                    </Container><br />
                    {/* IMAGENES Y DATOS DE HOMONIMO */}
                    <CitizenIdentityData citizenIdentityData={citizenIdentityData} showCitizenIdentityData={showCitizenIdentityData} closeShowCitizenIdentityData={ closeShowCitizenIdentityData } citizenIdentityDataGeneral={citizenIdentityDataGeneral}/>
                        {/* Modal confirmation add new candidate */}
                        <ModalConfirmation
                            actionAdd={sendDataConfirmation}
                            open={modalConfirmation}
                            closeModal={closeModalConfirmation}
                            titleButton="Sí, estoy seguro!"
                        >
                            <Typography className={classesModal.title} >
                                {messageModal}
                            </Typography>
                            <Typography className={classesModal.description} >
                                ¿Está seguro de continuar?
                            </Typography>
                        </ModalConfirmation>

                        {/* CASOS ESPECIALES */}
                        <ModalConfirmation
                            actionAdd={sendDataSpecialCase}
                            open={modalSpecialCase}
                            closeModal={closeModalSpecialCase}
                            titleButton="Sí, estoy seguro!"
                        >
                             <Typography className={classesModal.title} >
                                Al generar la solicitud por "Caso Especial", la solicitud pasará a estado de "Nueva solicitud"
                            </Typography>
                            <Typography className={classesModal.description} >
                                ¿Está seguro de enviar a caso especial?
                            </Typography>
                            <Typography className={classesModal.description} >
                                Los números de boletas seleccionados son:
                                {citizenDataSpecialCase?.map( ({nroBoleta}, index) => (
                                    <span className={classesModal.description} key={index}>
                                        {nroBoleta}, 
                                    </span>
                                ))}
                            </Typography>
                            <Grid className={classes.form}>
                                <Form elements={elements} />
                            </Grid>
                        </ModalConfirmation>
                </div>
            </Dialog>
        </div>
    );
}


Homonimos.defaultProps = {
    isManual: false
}

export default connect(mapStateToProps, mapDispatchToProps)(Homonimos);